import React from 'react';

export default function CustomIcon({ stroke = 'black', ...rest }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            version="1.1"
            id="Icons"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 32 32"
            {...rest}>
            <path
                d="M23,31H9c-4.4,0-8-3.6-8-8V9c0-4.4,3.6-8,8-8h14c4.4,0,8,3.6,8,8v14C31,27.4,27.4,31,23,31z"
                fill="none"
                stroke={stroke}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
            />
            <g>
                <path
                    d="M16,5c-1.1,0-1.7,0.1-2.8,0.6c-1.8,0.8-2.9,2.3-3.1,4.3c-0.1,1.1,0,2.3,0,3.4c0,0.4-0.2,0.6-0.6,0.4
                       c-0.2-0.1-0.4-0.2-0.5-0.2c-0.4-0.1-0.8-0.2-1.2-0.3c-0.3,0-0.6,0.1-0.7,0.4c-0.1,0.3-0.1,0.6,0.1,0.8c0.2,0.2,0.4,0.4,0.6,0.5
                       c0.5,0.4,1,0.7,1.5,1c0.4,0.3,0.5,0.7,0.4,1.2C9.5,18.1,9,19,8.4,19.7c-0.9,1-1.9,1.7-3.1,2.3c-0.4,0.2-0.4,0.4,0,0.6
                       c0.5,0.2,1,0.4,1.5,0.6c0.5,0.2,1.1,0.2,1.2,0.9c0.1,0.8,0.3,0.7,0.9,0.8c0.2,0,0.3,0,0.5,0c1.1,0,2.2,0.3,3.2,0.9
                       c0.6,0.4,1.2,0.7,1.8,0.9c1.6,0.5,3.2,0.3,4.6-0.7c1.1-0.8,2.4-1.1,3.7-1.1c0.2,0,0.4-0.1,0.7-0.1c0.4,0,0.5-0.2,0.6-0.6
                       c0-0.5,0.3-0.7,0.7-0.9c0.7-0.2,1.3-0.5,2-0.8c0.1,0,0.3-0.2,0.3-0.3c0-0.1-0.2-0.2-0.3-0.3c-0.6-0.4-1.3-0.7-1.9-1.2
                       c-1.2-0.9-2.1-2.1-2.6-3.5c-0.2-0.6-0.1-0.9,0.4-1.3c0.2-0.2,0.5-0.3,0.7-0.5c0.5-0.3,0.9-0.7,1.4-1c0.2-0.2,0.3-0.5,0.2-0.8
                       c-0.1-0.3-0.4-0.4-0.6-0.4c-0.3,0-0.5,0.1-0.8,0.1c-0.4,0.1-0.7,0.3-1,0.4c-0.3,0.1-0.6-0.1-0.5-0.4c0.1-1.2,0.1-2.4,0-3.5
                       c-0.1-1.1-0.6-2.1-1.3-2.9C19.3,5.6,17.8,5,16,5z"
                    fill="none"
                    stroke={stroke}
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
            </g>
        </svg>
    );
}
